<template>
    <div class="full-wdith-inputs" v-loading="loading">
        <div>
            <div style="margin-bottom: 50px">
                <div class="input-part">
                    <span class="label-span" tkey="密碼">{{i18n.tkey("lang_password")}}</span>
                    <br>
                    <el-input
                        v-model="password"
                        :placeholder="i18n.tkey('lang_password')"
                        type="password"
                        maxlength="18"
                    />
                </div>

                <div class="input-part">
                    <span class="label-span" tkey="確認密碼">{{i18n.tkey("lang_confirm_password")}}</span>
                    <br>
                    <el-input
                        v-model="confrimPassword"
                        :placeholder="i18n.tkey('lang_confirm_password')"
                        type="password"
                        maxlength="18"
                    />
                </div>
            </div>

            <el-collapse v-model="showPart">
                <el-collapse-item :title="i18n.tkey('lang_optional_information')" name="1">
                    <div class="input-part">
                        <span class="label-span" tkey="姓名">{{i18n.tkey("lang_name")}}</span>
                        <br>
                        <el-input
                            v-model="name"
                            :placeholder="i18n.tkey('lang_name')"
                            clearable
                            maxlength="28"
                            show-word-limit
                        />
                    </div>

                    <div class="input-part">
                        <span class="label-span" tkey="稱謂">{{i18n.tkey("lang_appellation")}}</span>
                        <br>
                        <MemmaleSelect v-model="memmale" />
                    </div>

                    <div class="input-part">
                        <span class="label-span" tkey="電話區號">{{i18n.tkey("lang_area_code")}}</span>
                        <br>
                        <AreaNumberSelect v-model="mpfaccount" />
                    </div>

                    <div class="input-part">
                        <span class="label-span" tkey="手機號碼">{{i18n.tkey("lang_mobile_number")}}</span>
                        <br>
                        <el-input
                            v-model="telephone"
                            :placeholder="i18n.tkey('lang_mobile_number')"
                            clearable
                            maxlength="46"
                            show-word-limit
                        />
                    </div>
                </el-collapse-item>
            </el-collapse>

            <div class="operation-box">
                <el-button size="large" type="primary" @click="clickSaveBtn" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
            </div>
        </div>

        <CardCompanyEditor
            :companyObj="editCompanyObj"
            v-if="null != editCompanyObj"
            @save-success="saveCallback"
        />
    </div>
</template>

<script setup>
    import {inject, ref, toRef, onBeforeMount} from "vue";
    import MemmaleSelect from "@/components/shopopee/form/memmaleSelect.vue";
    import AreaNumberSelect from "@/components/shopopee/form/areaNumberSelect.vue";
    import CardCompanyEditor from "@/components/shopopee/card/cardCompanyEditor.vue";
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    import userApi from "@/request/userApi";
    import companyApi from "@/request/companyApi";
    import cardApi from "@/request/api";

    const emits = defineEmits(["save-complete"])

    const i18n = inject("i18n")
    const loading = ref(false)

    const userInfoRef = toRef(useUserinfo())
    const showPart = ref("1")

    const password = ref("")
    const confrimPassword = ref("")
    const name = ref("")
    const memmale = ref(0)
    const telephone = ref("")
    const mpfaccount = ref("")

    const editCompanyObj = ref(null)

    function fillInfo(){
        password.value = userInfoRef.value.password
        confrimPassword.value = userInfoRef.value.password
        name.value = userInfoRef.value.name
        memmale.value = userInfoRef.value.memmale
        mpfaccount.value = userInfoRef.value.mpfaccount
        telephone.value = userInfoRef.value.telephone

        if (myUtil.isEmpty(mpfaccount.value)){
            mpfaccount.value = "+852"
        }

    }

    function clickSaveBtn(){
        const flag = checkInfo()

        if (flag){
            loading.value = true

            const request = userApi.updateDefaultPass
            const params = request.getParams()

            params.name = name.value
            params.addinfo2 = userInfoRef.value.addinfo2
            params.memmale = memmale.value
            params.mpfaccount = mpfaccount.value
            params.id = userInfoRef.value.id
            params.password = password.value
            params.telephone = telephone.value
            params.companycode = userInfoRef.value.companycode

            request.send(params, (res) => {
                if (res.code == 200){
                    inputInitCompanyinfo()
                }else{
                    myUtil.alertError(res.msg)
                    loading.value = false
                }
            })

        }
    }

    function inputInitCompanyinfo(){
        const request = companyApi.initNewCompanyInfo
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.companyname = userInfoRef.value.companyname
        params.email = userInfoRef.value.login
        params.telephone = userInfoRef.value.telephone
        params.address = "公司地址"
        params.login = userInfoRef.value.login
        params.userId = userInfoRef.value.id
        params.token = userInfoRef.value.token
        params.chatId = userInfoRef.value.addinfo2
        params.sharewhcom = mpfaccount.value

        request.send(params, (res) => {
            if (res.code == 200){
                insertDefaultMemberwork()
            }else{
                myUtil.alertError(res.msg)
                loading.value = false
            }
        })

    }

    //創建名片模板
    function insertDefaultMemberwork(){
        const request = cardApi.queryCompanyDefaultMemberWorkId
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.login = userInfoRef.value.login

        request.send(params, (res) => {
            if (res.code == 200){
                editCompanyObj.value = {
                    companycode: userInfoRef.value.companycode
                }
            }else{
                myUtil.alertError(res.msg)
                loading.value = false
            }
        })


    }

    function checkInfo(){
        const testExp = /['"\s]/

        if (testExp.test(password.value)){
            i18n.tkey("lang_format_warning_spc")
            return false
        }

        if (myUtil.isEmpty(password.value)){
            i18n.tkey("lang_enter_complete")
            return false
        }

        if (myUtil.isEmpty(confrimPassword.value)){
            i18n.tkey("lang_enter_complete")
            return false
        }

        if (password.value != confrimPassword.value){
            i18n.tkey("lang_password_inconsistent")
            return false
        }

        if (myUtil.isEmpty(name.value)){
            i18n.tkey("lang_enter_complete")
            return false
        }

        if (myUtil.isEmpty(telephone.value)){
            i18n.tkey("lang_enter_complete")
            return false
        }

        return true

    }

    function saveCallback(){
        userInfoRef.value.password = password.value

        loading.value = false
        editCompanyObj.value = null
        emits("save-complete")
    }

    onBeforeMount(() => {
        fillInfo()
    })

</script>

<style scoped>
    .full-wdith-inputs {
        width: 100%;
        text-align: left;
        line-height: 2;
    }

    .operation-box {
        width: 100%;
        text-align: center;
        margin-top: 30px;
    }

    .label-span {
        font-size: 12px;
        color: #606266;
        font-weight: 600;
    }

    .input-part {
        margin-bottom: 20px;
    }
</style>